import { forwardRef } from 'react';
import { Skeleton } from '@olxeu-jobs/ui';
import { Wrapper, Title, ContentWrapper } from './styled-components';
import type { SidebarWidgetProps } from './types';

export const SidebarWidget = forwardRef<HTMLElement, SidebarWidgetProps>(
  ({ title, loading, children, variant = 'default', ...props }, ref) => (
    <Wrapper $as="aside" $variant={variant} ref={ref} {...props}>
      {loading && (
        <Skeleton
          variant="image"
          width="100%"
          height="100%"
          $style={{ position: 'absolute', left: 0, top: 0 }}
        />
      )}
      <ContentWrapper $loading={!!loading}>
        {!!title && <Title $as="h3">{title}</Title>}
        {children}
      </ContentWrapper>
    </Wrapper>
  ),
);
